import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbb05332"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "建议反馈", -1))
const _hoisted_4 = { class: "type" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("p", null, "*"),
  /*#__PURE__*/_createElementVNode("div", null, "问题类型")
], -1))
const _hoisted_6 = { class: "pulllist" }
const _hoisted_7 = { class: "suggest" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("p", null, "*"),
  /*#__PURE__*/_createElementVNode("div", null, "建议反馈")
], -1))
const _hoisted_9 = { class: "phone" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "p" }, "上传图片"),
  /*#__PURE__*/_createElementVNode("div", null, "(最多上传5张、单张图片不超过5M)")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-jiahao1" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "max" }, "最多上传5张图片", -1))
const _hoisted_13 = { class: "contact" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("p", null, "*"),
  /*#__PURE__*/_createElementVNode("div", null, "联系方式")
], -1))
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("template", null, null, -1))
const _hoisted_17 = { class: "viprecord" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "record" }, " 感谢您对设纪元的关注与支持，我们会认真处 理您的反馈，尽快修复和完善相关功能。 ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button" }, "确定", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_html_footer = _resolveComponent("html-footer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Title = _resolveComponent("Title")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InvoiceDialog = _resolveComponent("InvoiceDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_home_head),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form, {
            model: _ctx.userSuggestForm,
            rules: _ctx.rules,
            ref: "ruleFormRef"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_form_item, { prop: "type" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "功能建议",
                      class: "job",
                      modelValue: _ctx.userSuggestForm.type,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userSuggestForm.type) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "功能建议",
                          value: "功能建议"
                        }),
                        _createVNode(_component_el_option, {
                          label: "体验反馈",
                          value: "体验反馈"
                        }),
                        _createVNode(_component_el_option, {
                          label: "其他",
                          value: "其他"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_el_form_item, { prop: "content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.userSuggestForm.content,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userSuggestForm.content) = $event)),
                      modelModifiers: { trim: true },
                      rows: 3,
                      type: "textarea",
                      placeholder: "请输入反馈内容 (不少于15字)"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_el_form_item, { prop: "mobile" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      "file-list": _ctx.userSuggestForm.photo,
                      "onUpdate:fileList": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userSuggestForm.photo) = $event)),
                      action: "",
                      multiple: "",
                      "list-type": "picture-card",
                      limit: "5",
                      "on-preview": _ctx.handlePictureCardPreview,
                      class: _normalizeClass({ nonejiahao: _ctx.userSuggestForm.photo.length >= 5 }),
                      "before-upload": _ctx.beforeUpload
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }, 8, ["file-list", "on-preview", "class", "before-upload"])
                  ]),
                  _: 1
                }),
                _hoisted_12
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_el_form_item, { prop: "connect" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.userSuggestForm.connect,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userSuggestForm.connect) = $event)),
                      placeholder: "请输入手机号或是邮箱"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_button, {
                round: "",
                class: "routine",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("提交")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ]),
      _createVNode(_component_html_footer)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.imgdialogVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.imgdialogVisible) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          style: {"width":"80%","margin-left":"10%"},
          src: _ctx.dialogImageUrl,
          alt: "Preview Image"
        }, null, 8, _hoisted_15)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_InvoiceDialog, {
      ref: "sonRef",
      dialogwidth: "580px"
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Title, {
          headerHeight: 40,
          headerBC: "#F2F5FA"
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ]),
      default: _withCtx(({}) => [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("i", {
              class: "iconfont",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mclose()))
            }, "")
          ]),
          _hoisted_19,
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}